'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _auditprogramdrgchanges = require('./auditprogramdrgchanges.component');

var _auditprogramdrgchanges2 = _interopRequireDefault(_auditprogramdrgchanges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auditprogramdrgchangesModule = _angular2.default.module('auditprogramdrgchanges', [_angularUiRouter2.default]).component('auditprogramdrgchanges', _auditprogramdrgchanges2.default);

exports.default = auditprogramdrgchangesModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogramdrgchanges/auditprogramdrgchanges.js